import type {AutosuggestListItem, GroupProps} from '../typedef';

export function isGroup<T>(item: AutosuggestListItem<T>): item is GroupProps<T> {
    // @ts-expect-error
    return !!(item.title && item.suggestionItems);
}
